import styled from 'styled-components';
import { Input, Select, Tooltip } from 'pcln-design-system';
import { Check, Warning, Success } from 'pcln-icons';
export const FormInput = /*#__PURE__*/styled(Input).withConfig({
  displayName: "OtpFormstyles__FormInput",
  componentId: "sc-1o432j1-0"
})(["background:#fff;"]);
export const ErrorToolTip = /*#__PURE__*/styled(Tooltip).withConfig({
  displayName: "OtpFormstyles__ErrorToolTip",
  componentId: "sc-1o432j1-1"
})(["z-index:100;margin-top:2px;"]);
export const CheckIcon = /*#__PURE__*/styled(Check).withConfig({
  displayName: "OtpFormstyles__CheckIcon",
  componentId: "sc-1o432j1-2"
})(["z-index:100;"]);
export const WarningIcon = /*#__PURE__*/styled(Warning).withConfig({
  displayName: "OtpFormstyles__WarningIcon",
  componentId: "sc-1o432j1-3"
})(["z-index:100;"]);
export const SuccessIcon = /*#__PURE__*/styled(Success).withConfig({
  displayName: "OtpFormstyles__SuccessIcon",
  componentId: "sc-1o432j1-4"
})(["z-index:100;"]);
export const SelectInput = /*#__PURE__*/styled(Select).withConfig({
  displayName: "OtpFormstyles__SelectInput",
  componentId: "sc-1o432j1-5"
})(["background:#fff;"]);